<script lang="ts">
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    export let placeholder = "";
    export let type: "text" | "tel" | "email" | "password" = "text";
    export let value = "";
    export let className: string | null = null;
    export let name: string | undefined = undefined;
    export let ref: null | HTMLInputElement = null;

    export { className as class };

    let dispatcher = createEventDispatcher<{
        change: {
            value: string;
            event: Event;
        };
    }>();
    const onInput = (event: Event & { currentTarget: HTMLInputElement }) =>
        dispatcher("change", {
            value: event.currentTarget?.value,
            event,
        });
</script>

<input
    {type}
    {placeholder}
    {value}
    {name}
    on:input={onInput}
    on:blur
    class={CN(className)}
    bind:this={ref}
    {...$$restProps}
/>
